export const EVENT_LOCATION_TYPES = [
  {
    label: 'event_location_types_onsite_label',
    value: 'offline',
  },
  {
    label: 'event_location_types_online_label',
    value: 'online',
  },
];

export const EVENT_MEETING_REPEATS = [
  {
    label: 'event_meeting_repeats_off_label',
    value: 'off',
  },
  {
    label: 'event_meeting_repeats_daily_label',
    value: 'daily',
  },
  {
    label: 'event_meeting_repeats_weekly_label',
    value: 'weekly',
  },
  {
    label: 'event_meeting_repeats_monthly_label',
    value: 'monthly',
  },
  {
    label: 'event_meeting_repeats_yearly_label',
    value: 'yearly',
  },
];

export const EVENT_WEEK_DAYS: { label: string; value: number }[] = [
  { label: 'monday', value: 1 },
  { label: 'tuesday', value: 2 },
  { label: 'wednesday', value: 3 },
  { label: 'thursday', value: 4 },
  { label: 'friday', value: 5 },
  { label: 'saturday', value: 6 },
  { label: 'sunday', value: 7 },
];

export const EVENT_MONTHS: { label: string; value: number }[] = [
  { label: 'january', value: 1 },
  { label: 'february', value: 2 },
  { label: 'march', value: 3 },
  { label: 'april', value: 4 },
  { label: 'may', value: 5 },
  { label: 'june', value: 6 },
  { label: 'july', value: 7 },
  { label: 'august', value: 8 },
  { label: 'september', value: 9 },
  { label: 'october', value: 10 },
  { label: 'november', value: 11 },
  { label: 'december', value: 12 },
];

export const EVENT_RECURRENCE_OFF = 'off';
export const EVENT_RECURRENCE_DAILY = 'daily';
export const EVENT_RECURRENCE_WEEKLY = 'weekly';
export const EVENT_RECURRENCE_MONTHLY = 'monthly';
export const EVENT_RECURRENCE_YEARLY = 'yearly';

export const EVENT_MONTHLY_BY_INTERVAL = 'interval';
export const EVENT_MONTHLY_BY_MONTHS = 'months';

export const EVENT_MONTHLY_BY_OPTIONS = [
  {
    label: 'event_monthly_by_interval_label',
    value: EVENT_MONTHLY_BY_INTERVAL,
  },
  {
    label: 'EVENT_MONTHLY_BY_MONTHS',
    value: EVENT_MONTHLY_BY_MONTHS,
  },
];

/** Relative "repeat on" option keys (distinct from day-of-month numbers). */
export const EVENT_REPEAT_ON_ORDINAL_FIRST = 'first';
export const EVENT_REPEAT_ON_ORDINAL_SECOND = 'second';
export const EVENT_REPEAT_ON_ORDINAL_THIRD = 'third';
export const EVENT_REPEAT_ON_ORDINAL_FOURTH = 'fourth';
export const EVENT_REPEAT_ON_ORDINAL_LAST = 'last';

export const EVENT_REPEAT_ON_ORDINAL_TO_VALUE: Record<string, number> = {
  [EVENT_REPEAT_ON_ORDINAL_FIRST]: 1,
  [EVENT_REPEAT_ON_ORDINAL_SECOND]: 2,
  [EVENT_REPEAT_ON_ORDINAL_THIRD]: 3,
  [EVENT_REPEAT_ON_ORDINAL_FOURTH]: 4,
  [EVENT_REPEAT_ON_ORDINAL_LAST]: -1,
};

export const EVENT_REPEAT_ON_VALUE_TO_ORDINAL: Record<number, string> = {
  1: EVENT_REPEAT_ON_ORDINAL_FIRST,
  2: EVENT_REPEAT_ON_ORDINAL_SECOND,
  3: EVENT_REPEAT_ON_ORDINAL_THIRD,
  4: EVENT_REPEAT_ON_ORDINAL_FOURTH,
  [-1]: EVENT_REPEAT_ON_ORDINAL_LAST,
};
